import type { Components } from '@mui/material/styles';

export default function MuiCollapse(): Components['MuiCollapse'] {
  return {};
}
